export type LabelStyleProps = {
  offLabel: string;
  onLabel: string;
};

export const labelStyle = ({ offLabel, onLabel }: LabelStyleProps) => ({
  '& .MuiSwitch-thumb:before': {
    content: `"${offLabel}"`,
  },
  '& .Mui-checked .MuiSwitch-thumb:before': {
    content: `"${onLabel}"`,
  },
});

export const formControlLabelStyle = {
  alignItems: 'flex-start',
  marginLeft: '0px',
  textTransform: 'uppercase',
  '& > .MuiFormControlLabel-label': {
    width: '100%',
    '& > .MuiInputLabel-root': {
      maxWidth: '100%',
    },
  },
  '& .MuiSlider-thumb.Mui-disabled': {
    background: 'gray',
  },
};
